<template>
  <el-aside  id="screen" width="100%" style="">

<div style="height:100%;width:100%; display: flex;flex-direction: column;">

    <div style="height:50px;width:100%;background-color:#f8f8f8;">
    
    <div  style="color:#970B0B;margin-top:15px;width:100%;height:50px" class="container_right">
      
    <div style="width:40%;display:flex" > 
      <div style="width:4px;background-color:#970B0B;height:40px"></div> 
      <div style="margin:5px;color:#970B0B;">设备地图</div> 
    </div>
    <div style="width:50%;justify-content: center;display: flex;">
       <div style="display: flex;margin-top:-11px">
            <el-input
            style="width:220px;"
             placeholder="请输入17位设备CID"
             v-model="cid"
             maxlength="17"
             type="text"
             clearable>
            </el-input>
        </div>
    </div>
    <div style="width:15%;color:#970B0B">
        <el-button  @click="RightAddClick"  size="mini" style="width:70%;background-color:#970B0B;color:#fff">查询</el-button> 

    </div>

    </div>

    </div>

        <el-button  @click="ChangeMapTileLayer"  type="primary" icon="el-icon-edit" style="z-index: 2;position: absolute;;display: flex;justify-content:center;margin-left: 10px;margin-top:240px;font-size:15px;color:#FFF">{{ mapTileLayer == 'RoadNet'  ? '矢量地图':'卫星地图'}}</el-button> 

      <div v-if="cid" :style="divStyle" style="z-index: 2;position: absolute;display: flex;justify-content:center;margin-left: 10px;margin-top:60px;font-size:15px;">设备状态：{{online}} | 硬件版本：{{version}} | 上报时间：{{deviceshowdata.reporttime}} | 地址：{{deviceAddress}}</div>

      <div  v-if="cid" :style="divStyle" style="z-index: 2;position: absolute;display: flex;flex-direction:row;flex-wrap: wrap;justify-content:center;margin-left: 10px;margin-top:80px;font-size:16px;">


         <div style="display: flex; justify-content: space-around; flex-wrap: wrap;">
                  <div  v-for="item in diyListArr" v-bind:key="item.id" v-on:click="CONTROLFUNC(item)" style="margin-left: 10px;display:flex;flex-direction:column">
                        <img   :src='item.current.icon' alt="Image" style="margin: 5px;width: 50px; height: 50px;" mode="aspectFit">
                         <div style="font-size: 14px;margin: 5px;width: 50px; height: 20px;text-align: center;"> {{item.sensor}}</div>
                  </div>

          </div>

         <div  v-for="item in showDiyStatusArr" v-bind:key="item.id" :style="divStyle" style="font-size:20px;margin:15px;">{{item.sensor}}: <span style="">{{item.value}}</span> {{item.unit}}</div>


      </div>

      <div v-if="!cid" style="display: flex;justify-content:center;margin-top:10px;font-size:15px;color:#999"> 请输入17位 设备CID，并点击《查询》按钮进行初始化！</div>



    <!--     <div style="margin-top:5px;padding:5px">
          
           <div style="display: flex; justify-content: space-around; flex-wrap: wrap;">
                  <div  v-for="item in diyListArr" v-bind:key="item.id" v-on:click="CONTROLFUNC(item)" style="display:flex;flex-direction:column">
                        <img   :src='item.current.icon' alt="Image" style="margin: 10px;width: 80px; height: 80px;" mode="aspectFit">
                         <div style="margin: 15px;width: 80px; height: 20px;text-align: center;"> {{item.sensor}}</div>
                  </div>

              </div>

        </div> -->








 <div  id="container" style="width: 100%;height: 660px;">    </div>


<!--   <div v-if="mapType == 'Googlemap'" >
    <gmap-map :center="google_centers" :zoom="16" style="width: 100%;height: 600px;" >
    <gmap-marker :position="google_position"/>
  </gmap-map>
  </div> -->



</div>
</el-aside>

</template>


<script>

import TMApipath from 'TMApipath'
import TMStore from 'TMStore'
import {wgs84togcj02,randomWordAll,formatTime,isJsonType} from 'TMUtils'
import TMConfig from 'TMConfig'

import jsonp from 'jsonp'

import { gmapApi } from 'vue2-google-maps'



import AMapLoader from '@amap/amap-jsapi-loader'
window._AMapSecurityConfig = {
    securityJsCode: '2aed15d0c7e44910e3df8c9b1e25ae41'  //填写你的安全密钥
}


export default {
  name: 'MapComponent',
  

  computed: {
      google: gmapApi, // 获取官方的OBject 使用官方API的时候可以用
    },


  methods: {

    updateMaker: function(latLng) {
        console.log('updateMaker, ', latLng.lat, latLng.lng)
        this.google_position = {
          lat: latLng.lat,
          lng: latLng.lng
        }
        this.google_centers = {
          lat: latLng.lat,
          lng: latLng.lng
        }
        
        this.pointToAddress(this.google_position.lat, this.google_position.lng, this.pushAddress)
      },
      pushAddress(res) {
                console.log('pushAddress：',res)

      },
      pointToAddress(lat, lng, backcall) {
        // 实例化Geocoder服务用于解析地址
        var geocoder = new this.google.maps.Geocoder();
        // 地理反解析
        geocoder.geocode({ location: new this.google.maps.LatLng(lat, lng) }, function geoResults(results, status) {
          if (status === this.google.maps.GeocoderStatus.OK) {
            backcall(results[0].formatted_address);
          } else {
            console.log('：error ' + status);
          }
        });
      },

    // 根据获取到的经纬度进行逆地理编码
    reverse(real, lng, lat) {
      var _this = this
      real.getAddress([lng, lat], (status, res) => {
        if (status === "complete") {
          // address即经纬度转换后的地点名称
          console.log(res, status);
          
          _this.deviceAddress = res.regeocode.formattedAddress

        }else{
                    console.log(res, status);

        }

      });

    },




      initMap() {
        var _this= this
            let load = AMapLoader.load({
                key: "b4c4f8072b2c8c3c1380f523a6119bf4",             // 申请好的Web端开发者Key，首次调用 load 时必填
                version: "2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                 plugins: ["AMap.Geolocation", "AMap.Geocoder"],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            }).then((AMap) => {
              this.AMap = AMap;
                this.map = new AMap.Map("container", {  //设置地图容器id
                    viewMode: "3D",    //是否为3D地图模式
                    zoom: 16,           //初始化地图级别
                    center: [116.397477, 39.908692], //初始化地图中心点位置
                });

                var timestamp = new Date().getTime() /1000;


                    // 自定义图层
                _this.customTileLayer = new AMap.TileLayer({
                        getTileUrl: function(x, y, z) {
                            return 'http://map.beidou6.com/api/Tile'  + '?p=com.fw.GeTai&lyrs=s,m&hl=en-CN&u=' + timestamp + '&x=' + x + '&y=' + y + '&z='+ z;
                        },
                        tileSize: 256
                    });



            }).catch(e => {
                console.log(e);
            })


           

            console.log(load)
        },

      ChangeMapTileLayer(){
        var _this =this

        if (_this.mapTileLayer == 'RoadNet') {

            _this.mapTileLayer = 'Satellite'
            
            _this.divStyle = {
               color:'#FFF'
            },

            // 添加自定义图层到地图
            _this.map.add( _this.customTileLayer);

        }else{
            
            _this.divStyle = {
               color:'#000'
            },
            _this.mapTileLayer = 'RoadNet'
            _this.map.remove(_this.customTileLayer);


        }
              // _this.marker = null

          

      },


      RightAddClick(){
        var _this =this

          if (!_this.cid || (_this.cid.length!=17)) {
              this.$message.error("请输入17位 CID");
            return
          }


        // 关掉已有的socket链接
        _this.connectStatus = '已断开';
        _this.connetIsOpen = false;
        _this.socket.close();
        clearTimeout(_this.heartBeatTimeOut);
        _this.socketClose = true;
        _this.stopHeartBeat();


        this.getSensorFunc()

        this.getSensorStatus()
   
        this.getOneDevice()


        

      },
       jsonp(url, params, callbackName) {
      // 构建查询字符串
      const query = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&')
      
      // 构建完整的URL，包含callback函数名
      const fullUrl = `${url}?${query}&${callbackName}=${callbackName}`
      
      // 发送JSONP请求
      return new Promise((resolve, reject) => {
        jsonp(fullUrl, (err, data) => {
          if (err) {
            reject(err)
          } else {
            resolve(data)
          }
        })
      })
    },

  coordTranslate(cc ){
    var _this = this


    var locations = wgs84togcj02(cc.longitude,cc.latitude);

      console.log('coordTranslate locations',locations)

      var longitude = locations[0]
      var latitude = locations[1]



      // if (_this.mapType == 'Googlemap') {
      // // begin google设置
      //         _this.google_position = {
      //           lat:  latitude,
      //           lng: longitude
      //         }

      //         _this.updateMaker(_this.google_position)

      //         _this.google_centers = _this.google_position

      // // end

      // }







      var position = new _this.AMap.LngLat(longitude, latitude); //Marker 经纬度

      //创建 AMap.Icon 实例：
      var icon = new _this.AMap.Icon({
        size: new _this.AMap.Size(25, 25), //图标尺寸
        image: "https://fairycloud.xyz/images/model/logo_map.jpg", //Icon 的图像
        // imageOffset: new _this.AMap.Pixel(-9, -3), //图像相对展示区域的偏移量，适于雪碧图等
        imageSize: new _this.AMap.Size(25, 25), //根据所设置的大小拉伸或压缩图片
      });


      console.log('coordTranslate 111')


    if ( _this.marker == null) {
       const marker = new _this.AMap.Marker({
            position: position,
            zoom:18,

            icon: icon, 
            title: cc.cid,
            // content: markerContent, //将 html 传给 content
            offset: new _this.AMap.Pixel(-13, -30), //以 icon 的 [center bottom] 为原点
          });

           _this.map.add(marker);
           _this.marker= marker;
      console.log('coordTranslate 22222')

        _this.map.setCenter([longitude, latitude]);


    }else{
      console.log('coordTranslate 3333')


        _this.marker.setPosition(position);
          // _this.marker.setCenter(position);
        _this.map.setCenter([longitude, latitude]);
        // map.setCenter([lng, lat]); //设置地图中心点

    }


    //实例逆向转码
    const Geocoder = new _this.AMap.Geocoder();
    _this.reverse(Geocoder, longitude, latitude);


      },

   
      
      
      
       wssInit(){
          var _this = this

          if (_this.socket && (typeof _this.socket.stop === "function")) {
             _this.socket.stop();
          }

          var reqdata = {cid: _this.cid, token:_this.token,aid: _this.aid}  
          var {urls} = _this.getresult(TMConfig.socketURL , '', reqdata);

         _this.socket = new WebSocket(urls);
         
          // console.log(urls)

         // _this.socket = new WebSocket(TMConfig.socketURL + '?cid='+ _this.cid + '&token=' + _this.token);
       
       
          _this.socket.onopen = function(){
            console.log("socket 连接成功！");

              _this.connectStatus = '已连接';
              _this.connetIsOpen = true;

             clearTimeout(_this.heartBeatTimeOut);

              _this.startHeartBeat()


          };
           _this.socket.onmessage = function(ev){

            var result = JSON.parse(ev.data);
            // console.log('上行原始报文：',  result);

                       

            if (_this.controlldid === result.did) {
                  _this.controlldid= ''
                  // console.log('_this.controlldid在入口匹配到')

                _this.$nextTick(() => {  _this.loadingInstance.close(); });
                
                 _this.$message({
                    message: '远控成功',
                    type: 'success',
                    duration: 1500
                  });
            }else{
              // console.log('入口没有匹配到',result.did)
              
            }


            if (result.cmdtype == "cmd_status"  ) {
           

                var cc = result;
                // _this.deviceshowdata.reporttime  = cc.reporttime
                _this.deviceshowdata = cc;

                _this.version = cc.version
                // console.log('cc.version:',cc.version)

              
                // if(cc){//部分用户可能没有拍照设置
                //   _this.setData({
                //     deviceshowdata: cc,
                //     reporttime:cc.reporttime 
                //   })
                // }

              var lsc = []

              //遍历需要字典数据 赋值界面展示
              _this.diyStatusListArr.forEach(ets => {

                    // var transdata =""
                      if (ets.istranslate) {
                          // var transarr =  ets.translatedata.split(',')
                          // for (var its in transarr) {
                          //   var cs = transarr[its].split(':')
                          //   var it = cs[0]
                          //   if (it == result[ets.typecode]) {
                          //     transdata =  cs[1]
                          //     break
                          //   }else{
                              
                          //   }
                          // }  
                        // lsc.push({name:ets.name,value: transdata })

                      } else {
                        lsc.push({sensor:ets.sensor, unit:ets.unit,value:result[ets.sensorname] })
                      }
                  });

                  _this.showDiyStatusArr = lsc
                  


                  

              var enwlis = []

              //遍历需要字典数据 赋值界面展示
              _this.diyListArr.forEach(its => {

                    var transdata = null ;

                    its.status.forEach(it => {

                      if (it.sensorcmd == result[its.sensorname]) {
    
                        its.current = it
                        transdata =  its

                        
                      }

                    })
                    
                    if (transdata != null) {
                      enwlis.push(transdata)

                    } else {
                      enwlis.push(its)

                    }

                  
              });

            // 更新定位信息

              if (Object.hasOwnProperty.call(cc, "latitude") && Object.hasOwnProperty.call(cc, "longitude")) {

                  _this.coordTranslate(cc);
              } else {
                console.log("3未匹配到经纬度：")
              }

          //     var url  = 'https://apis.map.qq.com/ws/coord/v1/translate?type=1&key=ZGVBZ-3X6LW-SHYRA-OXVZM-CHOF5-TEFOL&locations='+cc.latitude+','+cc.longitude

                
              } else if(result.cmdtype == "cmd_udpphotodata" & result.datatype == "hex" ){
              let url = result.udpphotodata;
              //  _this.setData({
                _this.videourl = url ;
              //   videotime: util.formatTime(new Date())
              //  })
            }else if(result.cmdtype == "cmd_takephoto"  ){
              let photourl = result.photourl;
              //  _this.setData({
                _this.photourl = photourl;
                // console.log('cmd_takephoto result:',result.photourl)
              //   takephototime: util.formatTime(new Date())
              //  })
            }else if(result.cmdtype == "cmd_controllack" ){
                //loading，control
              if (_this.controlldid === result.did || result.devicedatatype ==='HEX') {

                _this.controlldid= ''
           
                _this.$nextTick(() => {  _this.loadingInstance.close(); });
                 
                 //执行成功
                // _this.$message({
                //     message: '执行成功',
                //     type: 'success',
                //     duration: 1500
                //   });



                }
             

              }else if(result.cmdtype == "cmd_fotaack" ){
                  //loading，control
              
                    //FOTA类型判断
    
                    var fotastatus = result.fotastatus

                 
    
                    if (fotastatus === "fota_progress") {

                      console.log(`${result.toastmsg}: ${result.progress}%`)

                      //todo
                     _this.$nextTick(() => {  _this.loadingInstance.close(); });
                     _this.loadingInstance = _this.$loading({ fullscreen: true ,text:`${result.toastmsg}: ${result.progress}% 请勿操作设备！`});

    
                      if (result.progress === '100') {
                         _this.$message({
                              message: "升级成功，3S后设备自动上线",
                              type: 'success',
                              duration: 1500
                          });

                          _this.$nextTick(() => {  _this.loadingInstance.close(); });

                        setTimeout(function(){

                            _this.$router.push({name: 'DeviceDetail',query: {cid:_this.cid}})
                            _this.startHeartBeat()

      
                         },3000) 



                      }

                    
                     
                      
                    } else if (fotastatus === "fota_started") {

                     
                      //TODO
                      
                      var loading = result.loading;
                      if (loading === "show") {


                          console.log(result.toastmsg)

                          _this.$message({
                              message: result.toastmsg,
                              type: 'warning',
                               duration: 1500
                          });

                         _this.loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});
    
                      }


                      
                    }else if (fotastatus === "fota_finished") {
                      
                      _this.$message({
                          message: result.toastmsg,
                          type: 'success',
                           duration: 1500
                      });
                     _this.$nextTick(() => {  _this.loadingInstance.close(); });

                      
                    }else if (fotastatus === "fota_error") {
                      _this.$message.error(result.toastmsg);
                      
                    } else if (fotastatus === "fota_checked") {
                      
                       _this.$message({
                          message: result.toastmsg,
                          type: 'success',
                          duration: 1500
                      });

                      
                    } else {
                      console.log('fotastatus 没有匹配到：',fotastatus);
                      
                    }
    
                
    
            }else if(result.cmdtype == "cmd_statusack" ){
              //loading，control


              if (_this.controlldid === result.did || result.devicedatatype ==='HEX') {
                  // _this.setData({
                  //   controlldid: ''
                  // });
                  // wx.hideLoading()
                  console.log('cmd_statusack匹配到')

                    _this.controlldid  = ''
                  _this.$nextTick(() => {  _this.loadingInstance.close(); });

              }else{
                console.log('cmd_statusack没有匹配到 ')

              }
           

          }else{//为HEX类型数据解析

              console.log("未知类型数据：",result.cmdtype)
              console.log('上行原始报文：',  result);
              _this.$message({
                    message: result.errormsg,
                    type: 'warning',
                    duration: 1500
                });

            }





          };
           _this.socket.onclose = function(ev){
            console.log(ev)

                _this.socketClose = true;
                _this.stopHeartBeat();

              console.log("socket close");
              _this.connectStatus = '已断开';
              _this.connetIsOpen = false;
              _this.socket = null;
              // _this.connectWss()

          };
          _this.socket.onerror = function(ev){
            console.log(ev)

                _this.socket.close()
                console.log("socket on error");

                if (_this.heartBeatFailCount > 2) {
                  // 重连
                  _this.connectWss();
                }

                // if (_this.heart) {
                //   _this.heartBeatTimeOut = setTimeout(() => {
                //     _this.heartBeat();
                //   }, 30000);
                // }
                _this.heartBeatFailCount++;


          };

        },
        CONTROLFUNC(event) {
          var _this = this;

          // console.log(JSON.stringify(event));
          


            var current = event.current
            var sensorname = event.sensorname
            var cmd = event.cmd
            // var status = event.status


            var cmddata

            if (current.sensorcmd === "close") {
              cmddata =[sensorname,cmd[0].sensorcmd]
            }else{
              cmddata =[sensorname,'close']
            }

            var extdata = cmd[0].extdata

            // console.log("下行时间：",Math.round(new Date()))

            // return

            _this.handleSendMessage(cmddata,extdata)

        },

           // 开始心跳
        startHeartBeat: function() {
          console.log('socket链接成功，心跳开始')


          

          this.heart = 'heart'

          this.heartBeat();
        },
           // 结束心跳
      stopHeartBeat: function() {
        console.log('WebSocket 心跳已关闭！')
        var _this = this;
        _this.heart = ''

        if (_this.heartBeatTimeOut) {
          clearTimeout(_this.heartBeatTimeOut);
          _this.heartBeatTimeOut = null;
        }
        if (_this.connectSocketTimeOut) {
          clearTimeout(_this.connectSocketTimeOut);
          _this.connectSocketTimeOut = null;
        }
      },

      // 心跳
      heartBeat: function() {
        var _this = this;

        if (!_this.heart) {
          return;
        }

        
        var htts = _this.combineDataWithFlag()//心跳
        
        if (!htts) {
            return
          }

          var cdata = Date.now() 

          var cjson ={
            did: randomWordAll(),
            
            reporttime: formatTime(cdata),
            
            devicedatatype :  _this.deviceInfo.devicedatatype,

            cmdtype:"cmd_status",
            cmddata:{
            },
            cid: htts.cid
          }
          htts.devicedatatype =  _this.deviceInfo.devicedatatype;

          htts.jsondata = cjson;

//TODO
         _this.socket.send(JSON.stringify(htts));






      },
       combineDataWithFlag(){
          var _this = this;
          var carData = {}
       
          carData.token = _this.token;
          carData.cid = _this.cid;
          carData.aid = _this.aid;
          carData.origin = "web";
          carData.username = _this.username;

          return carData
        },
        // 向服务器发送消息
        handleSendMessage: function (msg,extdata) {
              var _this = this;


              if (!_this.connetIsOpen) {
         
                _this.wssInit()
                return
              }
              
              if (!msg) {
                  return
              }

              var htts = {}

              // if (_this.deviceInfo.devicedatatype == "JSON") {


                    htts = _this.combineDataWithFlag()//心跳
                    if (!htts) {
                      console.log('!htts xxx')

                      return
                    }

                    var cdata = Date.now() 


        
                  var cjson ={
                    did: randomWordAll(),
                   
                    reporttime: formatTime(cdata),
                    
                    devicedatatype :  _this.deviceInfo.devicedatatype,

                    cmdtype:"cmd_controll",
                    cmddata:{
                      sensorname:msg[0],
                      sensorcmd:msg[1],
                      extdata:extdata
                    },
                    cid: htts.cid,
                    origin: "web",
                    username: _this.username,

                  }
                  htts.jsondata = cjson;


              htts.devicedatatype =  _this.deviceInfo.devicedatatype;


// console.log('_this.deviceInfo.devicedatatype :',_this.deviceInfo.devicedatatype )

                _this.controlldid= cjson.did
                // console.log("controlldid:",_this.controlldid)
              

              
            // } else if (_this.deviceInfo.devicedatatype == "HEX") {
            //   // console.log('功能未完善-下行报文：', msg)
            
            // }
            
            _this.loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});

            setTimeout(() => {
                _this.$nextTick(() => {  _this.loadingInstance.close(); });

           if (_this.controlldid) {
                    _this.$message({
                    message: '远控失败，设备无响应',
                    type: 'warning',
                    duration: 2000
                  });

                }
              

            }, 5000);


           _this.socket.send(JSON.stringify(htts));
        },

        getLastHome(){

          var _this = this

          var reqdata = {cid: _this.cid}  
          var { urls} = _this.getresult(TMApipath.LOGSERVER, TMApipath.URL_API_GETLASTHOME, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls,reqdata ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录


                    var result = response.data.result;

                    if (result==null || !isJsonType(result.data)) {
                      console.log('result为null，或不是json')
                      return
                    }


           
                    var cc = JSON.parse(result.data);
                    result = cc
                    
                    _this.version = cc.version

                    cc.photourl = 'https://fairycloud.xyz/photos/'+ cc.photoname
                    cc.videourl = 'https://fairycloud.xyz/photos/'+ cc.videoname

                    if(cc){//部分用户可能没有拍照设置

                        _this.deviceshowdata = cc;
                        _this.reporttime = cc.reporttime ;

                    }

                  var lsc = []
                

                  _this.diyStatusListArr.forEach(ets => {

                    // var transdata =""
                      if (ets.istranslate) {
                          // var transarr =  ets.translatedata.split(',')
                          // for (var its in transarr) {
                          //   var cs = transarr[its].split(':')
                          //   var it = cs[0]
                          //   if (it == result[ets.typecode]) {
                          //     transdata =  cs[1]
                          //     break
                          //   }else{
                              
                          //   } 
                          // }  
                        // lsc.push({name:ets.name,value: transdata })

                      } else {
                        lsc.push({sensor:ets.sensor,unit:ets.unit,value:result[ets.sensorname] })
                      }
                  });
                  _this.showDiyStatusArr = lsc


              // 更新定位信息

              if (Object.hasOwnProperty.call(cc, "latitude") && Object.hasOwnProperty.call(cc, "longitude")) {



                  _this.coordTranslate(cc);
              } else {
                console.log("3未匹配到经纬度：")
              }

               



            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },
      // getLastPhoto(){

      //     var _this = this

      //     var reqdata = {cid: _this.cid}  
      //     var { urls} = _this.getresult(TMApipath.LOGSERVER, TMApipath.URL_API_GETLASTPHOTO, reqdata);


      //      let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


      //     _this.axios.get(urls,reqdata ).then((response) => {
      //       _this.$nextTick(() => {  loadingInstance.close(); });
      //       if (response.status ) {
      //         // vuex记录


      //               var result = response.data.result;

                   
                    
      //               _this.photourl = result.photourl


      //       }else{
      //         this.$message.error(response.msg);
      //       }
      //     }, (response) => {
      //       _this.$nextTick(() => {  loadingInstance.close(); });
      //       console.log(response)
      //     });

      // },
      getSensorStatus(){

          var _this = this

          var params={
            cid: _this.cid
          }

          var reqdata = {}  
          var { urls} = _this.getresult(TMApipath.DEVICEANDFUNC, TMApipath.URL_API_GETSENSORSTATUS, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.post(urls,params ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录



                var nlist = []
                var diylist = []
                var datas = response.data.result

                  // var item = response.data.result

                  // var datas = JSON.parse( item.data)

            
                for (var items in datas) {
                    var icc = datas[items]
                    nlist.push(icc)
                    diylist.push({
                        value:icc.value,
                        sensor:icc.sensor,
                        unit: icc.unit
                    })

                }

                  _this.diyStatusListArr = nlist,
                  _this.showDiyStatusArr = diylist

                 _this.getLastHome()
                 // _this.getLastPhoto()


            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },
        getSensorFunc(){

          var _this = this

          var params={
            cid: _this.cid
          }

          var reqdata = {}  
          var { urls} = _this.getresult(TMApipath.DEVICEANDFUNC, TMApipath.URL_API_GETSENSORFUNC, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.post(urls,params ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录


                var nlist = []
                for (var items in response.data.result) {
                  var item = response.data.result[items]

                  var datas = JSON.parse( item.data)


                

                  var cutFeed = {
                    sensor: datas.sensor,
                    sensorname: datas.sensorname,
                    cmd: datas.cmd,
                    status: datas.status,
                    current: datas.status[1]
                  }

                    if (datas.sensorname =="camera") {
                      _this.showVideo = true

                    }else if (datas.sensorname =="takephoto") {
                       _this.showPhoto = true
                      
                    }

                  nlist.push(cutFeed)

                }
                  _this.diyListArr = nlist;



            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },
      getOneDevice(){

          var _this = this

          var reqdata = {cid: _this.cid}  
          var { urls} = _this.getresult(TMApipath.DEVICE, TMApipath.URL_API_GETONEDEVICE, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls,reqdata ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录

                _this.deviceInfo = response.data.result[0];
                _this.deviceInfo.cid = response.data.cid;
                _this.online = response.data.result[0].online == 1 ? "在线":"离线";

                // console.log('deviceInfo:',_this.deviceInfo)



                _this.connectStatus = '已断开';
                _this.connetIsOpen = false;

                if (_this.socket) {
                   _this.socket.close();
                }

                _this.wssInit();


            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },




    },
    beforeDestroy(){
      var _this = this

        // 关掉已有的socket链接
        _this.connectStatus = '已断开';
        _this.connetIsOpen = false;
        _this.socket.close();
        clearTimeout(_this.heartBeatTimeOut);
        _this.socketClose = true;
        _this.stopHeartBeat();
    },
    mounted() {

      var _this = this


//DOM初始化完成进行地图初始化
        this.initMap()



      this.cid = this.$route.query.cid 
      this.updateversion = this.$route.query.updateversion 
      this.updateurl = this.$route.query.updateurl 


      this.token = TMStore.state.account.token
      this.aid = TMStore.state.account.aid 
      this.username = TMStore.state.account.username 

      if(_this.cid == '' || typeof(_this.cid ) == "undefined"){
         console.log('cid为空')
         _this.cid = ''
          



      }else{
         console.log('cid',_this.cid)
        setTimeout(function(){

            _this.getSensorFunc()
            _this.getSensorStatus()
            _this.getOneDevice()
        },1000) 
          // _this.connectStatus = '已断开';
          // _this.connetIsOpen = false;

          // if (_this.socket) {
          //    _this.socket.close();
          // }

          // _this.wssInit();
       
      }


      //延时执行FOTA任务，等待SOCKET连接
      setTimeout(function(){
           
           if ( (typeof(_this.updateversion) !="undefined") && _this.cid !='' && _this.updateversion!='' && _this.updateurl != '') {

            // console.log(_this.updateversion +' ' +_this.updateurl);

              if (_this.connetIsOpen) {

                var fotadatastr = `{"sensor":"FOTA升级","sensorname":"fota","cmd":[],"current":{"sensorcmd":"close","notes":"关闭","icon":"https://fairycloud.xyz/images/fota_close.png"}}`

                fotadatastr = JSON.parse(fotadatastr);

                // var extdata = {
                //   updateurl:_this.updateurl,
                //   updateversion:_this.updateversion
                // }

                var dicss = {
                    sensorcmd:  "open",
                    notes:  "开启",
                    extdata : {
                        updateurl: _this.updateurl,
                        updateversion: _this.updateversion,
                    }
                }

                fotadatastr.cmd.push(dicss);

                _this.CONTROLFUNC(fotadatastr);

              }else{

               console.log('updateversion 是吧 未连接服务器xxxxxxxxxx')
              }
            }else{
              console.log('不是升级跳转')
            }


        },1000) 

    },
    data() {
      return {
        mapTileLayer : 'RoadNet',
        // google_centers:{
        //   lat: 39.8074498,
        //   lng: 116.5345777
        //  },

        //  google_position: {

        //   lat: 39.8074498,
        //   lng: 116.5345777
        // },
          divStyle:{
            color:'#000'
          },
          deviceshowdata:{reporttime:''},
          deviceInfo:{},
          diyStatusListArr: [],
          message:'',
          controllLoading: false,
          controlldid: '',
          fotaloading:false,
          loadingInstance:'',

          showDiyStatusArr: [],
          aid: '',
          token:'',
          cid:'',
          updateDate:'',
          connectStatus: '已断开',
          connetIsOpen:false,
          socket:'',
          heart : '',
          heartBeatFailCount : 0,
          heartBeatTimeOut : null,
          diyListArr:[],
          groupIist: [],
          online: '--',
          version: '--',
          videourl: 'https://fairycloud.xyz/images/videophoto.png',
          photourl: 'https://fairycloud.xyz/images/videophoto.png',
          showVideo: false,
          showPhoto: false,
          latitude: 35.9811888,
          longitude: 120.1614471,

          map: null,
          customTileLayer: null,
          marker: null,
          deviceAddress: null


      }
    }
  }
</script>

<style lang="stylus" scoped>
.groups
    overflow: hidden

.rightButton
  width: 30px
.container_right
    margin: 5px
    display: flex
    justify-content: center
    align-items: flex-start
.el-dialog_header
    padding:0px
</style>